import React from "react";
import PropTypes from "prop-types";

import Icon from "../icon/icon";
import { gatherClasses, isObject } from "../../lib/utils";

const SmallMessageBox = ({ primaryText, icon }) => {
  return (
    <div className="oui-mbx-small">
      {isObject(icon) &&
        icon !== null &&
        (React.isValidElement(icon) ? (
          React.cloneElement(icon, {
            className: gatherClasses(
              null,
              "oui-mbx-icon",
              icon.props.className
            ),
            size: "sm",
            width: null,
            height: null
          })
        ) : (
          <div className="oui-mbx-icon">
            <Icon
              {...icon}
              width="16px"
              height="16px"
              className={gatherClasses(null, icon.className || "")}
            />
          </div>
        ))}
      <div className="oui-mbx-text-primary">{primaryText}</div>
    </div>
  );
};

SmallMessageBox.defaultProps = {
  primaryText: ""
};

SmallMessageBox.propTypes = {
  icon: PropTypes.object,
  primaryText: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
};

SmallMessageBox.displayName = "OrionMessageBoxSmall";

export default SmallMessageBox;
